"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statesman = void 0;
const Turmoil_1 = require("../../turmoil/Turmoil");
const IAward_1 = require("../IAward");
class Statesman {
    constructor() {
        this.name = 'Statesman';
        this.description = 'Have the most party leaders and influence combined';
    }
    getScore(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const partyLeaderCount = turmoil.parties.filter((party) => party.partyLeader === player.id).length;
        let score = partyLeaderCount + turmoil.getPlayerInfluence(player);
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Statesman = Statesman;
//# sourceMappingURL=Statesman.js.map